import React from 'react';
import classnames from 'classnames';
import styles from './Popup.module.scss';
import { Cross } from '../../../images';

/**
 * @type {React.FC<any>}
 * @deprecated Use Modal component instead
 */
const Popup = React.memo(function Popup({
  title = '',
  isOpen = false,
  children,
  wrapperClassName = null,
  close = null,
  className = null,
}) {
  if (!isOpen) {
    return false;
  }

  return (
    <div className={classnames(styles.root, wrapperClassName)}>
      <div className={classnames(styles.popup, className)}>
        {close && (
          <button type="button" className={styles.closeButton} onClick={close}>
            <img src={Cross} className={styles.close} alt="close" />
          </button>
        )}
        {title && <h5 className={styles.title}>{title}</h5>}
        <div className={title ? styles.body : null}>{children}</div>
      </div>
    </div>
  );
});

export { Popup };
